import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme) => ({
    wrapper: {
      paddingBottom: theme.spacing(0.5) + 'px !important',
    },
    root: {
      backgroundColor: 'white',
      padding: theme.spacing(2),
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,
    },
    title: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
    },
    csvUpload: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
    },
    fieldTitle: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1),
      fontWeight: theme.typography.fontWeightMedium,
    },
    briefRow: { marginTop: theme.spacing(2) },
    briefRowGenPanel: { marginTop: theme.spacing(3) },
    rowPanel: {
      margin: theme.spacing(1, -2, 1),
    },
    rowPersonas: {
      margin: theme.spacing(1, -2, 2, -2),
    },
    row: {
      margin: theme.spacing(-1, -2, -2, -2),
    },
    loader: { paddingTop: theme.spacing(3) },
  }),
  { name: 'BlockMultiPrompt' }
);
